<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { LoaderIcon } from 'vue-tabler-icons';

const store = useStore();
const route = useRoute();

const loading = ref(true);
const currentCI = computed(() => store.getters['ci/currentCItem']);

onMounted(async () => {
  loading.value = true;

  try {
    await store.dispatch('ci/fetchCItemById', route.params.ciId);
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <section class="ci-container">
    <div v-if="loading" class="ci-container__loader">
      <loader-icon class="animate h-12 w-12 animate-spin" style="animation-duration: 7s" />
    </div>
    <div v-else-if="currentCI" class="flex h-full w-full flex-grow flex-col gap-6 rounded-l-2xl">
      <router-view :item="currentCI" :draft="currentCI.revisions[0]" />
    </div>
    <div v-else>404</div>
  </section>
</template>

<style scoped lang="postcss">
.ci-container {
  @apply relative flex h-full w-full flex-col gap-6;
}

.ci-container__loader {
  @apply absolute top-0 left-0 flex h-full w-full items-center justify-center text-4xl;
  @apply bg-black bg-opacity-20  text-brand-600;
}
</style>
